import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// 🔐 Basic Protection - Disable Right Click Globally
document.addEventListener('contextmenu', e => {
  e.preventDefault();
  return false;
});

// 🔐 Basic Protection - Disable Text Selection Globally
document.addEventListener('selectstart', e => {
  e.preventDefault();
  return false;
});

// 🔐 Basic Protection - Disable Copy/Paste/Cut Globally
document.addEventListener('copy', e => {
  e.preventDefault();
  return false;
});

document.addEventListener('paste', e => {
  e.preventDefault();
  return false;
});

document.addEventListener('cut', e => {
  e.preventDefault();
  return false;
});

// 🔐 Basic Protection - Disable Developer Tools Shortcuts
document.addEventListener('keydown', e => {
  // F12, Ctrl+Shift+I, Ctrl+Shift+J, Ctrl+U
  if (e.keyCode === 123 || // F12
      (e.ctrlKey && e.shiftKey && (e.keyCode === 73 || e.keyCode === 74)) || // Ctrl+Shift+I/J
      (e.ctrlKey && e.keyCode === 85)) { // Ctrl+U (View Source)
    e.preventDefault();
    return false;
  }
});

// 🔐 Basic Protection - Disable View Source
document.addEventListener('keydown', e => {
  if (e.key === 'F12' || (e.ctrlKey && e.shiftKey && e.key === 'I')) {
    e.preventDefault();
    return false;
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
